import Vue from 'vue';

Vue.component('amount-vue', {

  props: {
    amountDefault: {
      type: String,
      default: ''
    },
    isValid: {
      default: true
    }
  },

  data: function () {
    return {
      customAmountValue: '',
      radioValue: this.amountDefault
    }
  },

  computed: {
    internalValue: function () {
      return this.radioValue || this.customAmountValue;
    }
  },

  watch: {
    customAmountValue: function (val) {
      val = parseFloat(val.replace(/\$|,/g, '')).toString();
      if (val) {
        this.radioValue = '';
      }
    },

    internalValue: function(val) {
      this.$emit('update:amount', val, this.customAmountValue);
      this.handleChange();
    }
  },

  mounted() {
    this.$emit('update:amount', this.radioValue || '0');
    this.$amountInput = $(this.$refs.amountInput);
  },

  methods: {
    onRadioValueChanged(val) {
      this.radioValue = val;
      this.$refs.customAmount.value = '';
    },

    handleChange() {
      this.$nextTick(() => {
        if (typeof this.$amountInput.valid === 'function') {
          this.$amountInput.valid();
        }
      });
    }
  }
});
